var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDentistCaricature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 296.049,
    height: 660,
    viewBox: "0 0 296.049 660",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.13;}.b{fill:#44484f;}.c{fill:#231919;}.d,.r{opacity:0.1;}.e,.o,.p,.r{fill:#fff;}.e{opacity:0.05;}.f{fill:#2b2727;}.g{opacity:0.17;}.h{fill:#eb937f;}.i{fill:#a4d4e0;}.j{fill:#4f1e0f;}.ab,.k{opacity:0.07;}.l{fill:#ff9f85;}.m{fill:#3d1208;}.n{fill:#784c4a;}.p{opacity:0.15;}.q{fill:#471408;}.s{fill:#eaeaea;}.t{fill:#355b59;}.u{fill:#c3dbd9;}.v{fill:#c6c6c6;}.w{opacity:0.09;}.x{fill:#f9f9f9;}.y{fill:#e38f7a;}.z{fill:#fba386;}.aa{fill:#fda688;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-230 -49.78)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M230,427.626s58.909-20.091,150.417-20.091,145.632,23.454,145.632,23.454-58.332,17.372-145.2,17.169C274.387,447.908,230,427.626,230,427.626Z",
    transform: "translate(0 261.62)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M319.042,412.894l-20.1-.764-3.619-24.475,20.244-2.994Z",
    transform: "translate(47.771 244.893)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M280.7,418.712c10.53,3.3,34.3-19.5,38.838-23.758,0,0,5.86,5.706,20.247-.116,10.045,4.924,9.385,27.721,8.8,35.959a3.438,3.438,0,0,1-3.194,3.187l-18.431,1.305a2.422,2.422,0,0,1-2.588-2.245l-.14-1.974-18.663,6.472c-18.661,6.471-40.244-2.294-40.244-2.294l-.156-7.344C265.017,420.561,270.174,415.414,280.7,418.712Z",
    transform: "translate(25.718 252.335)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M316.713,393.957c-4.093,1.669-12.986,2.223-20.341.779l-1.047-7.081,20.244-2.993Z",
    transform: "translate(47.771 244.893)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M280.694,417.113c8.7,2.727,26.433-12.361,34.894-20.088,17.7,12.117,1.141,29.165-15.659,31.248-11.044,1.369-23.757,1.158-34.747-2.7C265.378,418.63,270.521,413.927,280.694,417.113Z",
    transform: "translate(25.728 253.934)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(317.858 414.731)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M317.838,272.562c-.121.5-3.056,63.85,17.384,201.971.334,2.254-.765,4.446-3.023,4.766l-29.385,2.69c-2.6.239-5.384-1.307-5.789-3.89C275.451,340.454,281.4,269.64,281.782,260.578Z",
    transform: "translate(-280.747 -260.578)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M368.806,413.548l-20.1-.764-3.62-24.475,20.245-2.994Z",
    transform: "translate(84.163 245.371)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M366.115,391.676c-8.078,3.675-14.749,4.145-20.145,2.583l-.881-5.95,20.246-2.993Z",
    transform: "translate(84.162 245.371)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(383.942 404.572)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M356.425,254.71c-.121.5-4.553,102.828,36.466,223.541a3.857,3.857,0,0,1-3.193,5.144l-30.519,3.137a4.724,4.724,0,0,1-4.936-3.142c-51.1-146.238-32.21-217.771-30.6-223.488Z",
    transform: "translate(-318.918 -254.71)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "g",
    transform: "translate(317.863 414.731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.544,316.62q-7.892-.67-15.713-1.757a160.453,160.453,0,0,1-21.94-4.673c-.557-29.151.718-45.564.89-49.612l36.056,11.984C317.779,272.8,317.095,287.07,318.544,316.62Z",
    transform: "translate(-280.75 -260.578)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "g",
    transform: "translate(383.945 404.572)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358.719,315.966a130.127,130.127,0,0,1-14.676,3.321A190.138,190.138,0,0,1,319.3,321.7c-1.837-38.665,3.518-58.872,4.345-61.8l32.777-5.192C356.366,254.947,355.329,278.4,358.719,315.966Z",
    transform: "translate(-318.92 -254.71)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M330.469,419.367c10.53,3.3,34.3-19.5,38.838-23.76,0,0,5.86,5.706,20.246-.116,9.815,4.813,9.411,26.684,8.842,35.368a4.089,4.089,0,0,1-3.792,3.817l-16.826,1.193a3.474,3.474,0,0,1-3.712-3.218l-.066-.926L355.337,438.2c-18.663,6.472-40.244-2.3-40.244-2.3l-.156-7.342C314.78,421.214,319.937,416.069,330.469,419.367Z",
    transform: "translate(62.111 252.813)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M366.762,414.126c-2.929,5.665-9.434,8.76-15.41,9.9-8.99,1.717-18.622-.365-25.543-5.784,9.541-.911,24.8-14.113,32.119-20.838C364.01,401.075,370.481,406.934,366.762,414.126Z",
    transform: "translate(70.063 254.212)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M362.692,165.941c1.309-9.117,2.469-18.248,3.165-27.432-16.627-3.641-43.2-2.14-50.107-1.548a151.438,151.438,0,0,0-20.838,3.064c1.4,6.648,1.4,13.53,2.7,20.254C319.4,160.421,341.016,163.583,362.692,165.941Z",
    transform: "translate(47.469 63.159)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M314.485,254.627q-18.311,1.441-36.6,3.09c.528-39.044,3.835-71.509,2.32-87-1.108-11.342,8.816-26.66,19.832-29.577A88.329,88.329,0,0,1,313.3,138.8c1.66,11.2,13.447,21.208,24.634,19.262,12.164-2.114,16.852-10.2,17.881-21.866,16.224-.263,25.024,7.019,36.27,11.364,3.566,3.826,4.714,49.262,4.465,101.306C369.146,250.254,341.731,252.484,314.485,254.627Z",
    transform: "translate(35.015 63.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M318.832,149.132a3.606,3.606,0,0,0-3.669,3.061c-2.76,18.114-22.069,108.489-21.392,116.636.753,9.058,13.781,16.568,13.781,16.568s12.732-7.663,14.453-17.978c1.558-9.344.925-98.737-.265-115.515a2.986,2.986,0,0,0-2.909-2.774Z",
    transform: "translate(46.622 72.653)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M305.506,208.984a9.587,9.587,0,0,0,8.887-1.884c.329,9.087.395,15.729.029,17.927-1.073,6.428-6.42,11.823-10.3,14.979C304.616,236.9,305.125,224.667,305.506,208.984Z",
    transform: "translate(54.206 115.046)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M314.827,112.373l3.142.007c6.783.016,11.139,7.344,11.122,14.129l-.443,37.718c-.016,6.783-4.037,8.289-10.82,8.272l-3.142-.007c-6.783-.016-12.642-4.3-12.626-11.08l.405-36.734A12.369,12.369,0,0,1,314.827,112.373Z",
    transform: "translate(52.695 45.773)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M314.751,112.372l3.142.009c6.783.016,11.139,7.344,11.122,14.129l0,17.463c-7.01,4.688-20.788,5.194-26.854,1.143l.225-20.438A12.372,12.372,0,0,1,314.751,112.372Z",
    transform: "translate(52.771 45.773)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M287.2,126.827s-15.128-7.3-10.824-29.408C279.592,80.911,288.373,74.2,288.373,74.2s-3.5-7.064,3.5-14.787,12.154,1.946,12.154,1.946,10.3-16.085,45.863-4.377C377.96,66.229,376.45,75.47,376.45,75.47s11.487-9.943,17.927,2.9c6.738,13.436-3.2,16.437-3.2,16.437s13.829,13.149,3.345,30.853C386.49,139.221,287.2,126.827,287.2,126.827Z",
    transform: "translate(33.352 2.146)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M284.544,115.138c.222-.043.443-.017.665-.04l-.338-9.131a41.225,41.225,0,0,1,39.556-42.6l17.155-.635a41.227,41.227,0,0,1,42.6,39.558l.3,8.066a7.8,7.8,0,0,1,5.93-1.056c4.969,1.252,7.633,7.683,5.95,14.366-1.569,6.236-6.366,10.426-11.037,9.951a41.217,41.217,0,0,1-39.553,42.25l-17.153.635c-21.7.8-50.185-12.675-42.364-36.925-3.89-.978-7.348-4.981-8.409-10.339C276.5,122.453,279.5,116.139,284.544,115.138Z",
    transform: "translate(34.75 9.454)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M335.526,60.872s.007-.073.021-.192C335.929,60.973,335.957,61.063,335.526,60.872Z",
    transform: "translate(77.169 7.971)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M276.389,97.29c3.213-16.508,11.994-23.218,11.994-23.218s-3.5-7.064,3.5-14.787,12.154,1.946,12.154,1.946,7.91-15.715,43.469-4c28.074,9.243,28.959,18.114,28.959,18.114s14.728-11.122,21.168,1.721c6.738,13.438-6.442,17.618-6.442,17.618a26.681,26.681,0,0,1,6.442,11.349c-10.012,4.759-12.927,14.347-15.019,24.5-2.258.36-4.095.059-7.678-.852,1.254-18.724,5.675-38.028-5.145-44.13-53.476-30.161-85.579-2.642-83.169,36.736C282.033,119.485,272.84,115.516,276.389,97.29Z",
    transform: "translate(33.341 2.275)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M327.591,63.06c-1.094,5.62,3.021,11.149,9.193,12.351s12.064-2.377,13.158-8-3.021-11.149-9.193-12.351S328.686,57.44,327.591,63.06Z",
    transform: "translate(71.238 3.694)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M290.61,58.591a9.273,9.273,0,1,0,10.8-6.994A9.1,9.1,0,0,0,290.61,58.591Z",
    transform: "translate(44.205 1.198)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M278.059,68.28c-.944,4.842,1.612,9.415,5.706,10.211s8.179-2.479,9.122-7.322-1.612-9.413-5.706-10.211S279,63.439,278.059,68.28Z",
    transform: "translate(35.001 8.088)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M314.224,56.863c-1.025,5.263,4.751,10.819,12.9,12.406s15.59-1.392,16.615-6.657-4.751-10.819-12.9-12.406S315.249,51.6,314.224,56.863Z",
    transform: "translate(61.505 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M328.929,62.6c.994-5.1-4.929-10.544-13.227-12.161s-15.831,1.207-16.823,6.305S303.806,67.287,312.1,68.9,327.935,67.7,328.929,62.6Z",
    transform: "translate(50.29 0.149)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M275.1,78.776c-1.157,5.94.58,11.278,3.881,11.922s6.917-3.653,8.073-9.593-.58-11.279-3.882-11.922S276.259,72.834,275.1,78.776Z",
    transform: "translate(32.719 14.143)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M274.454,90.846c1.233,4.082,4.475,6.716,7.242,5.879s4.013-4.822,2.781-8.906S280,81.106,277.233,81.94,273.221,86.764,274.454,90.846Z",
    transform: "translate(32.16 23.406)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M340.729,80.1c-.608,3.115,1.719,6.189,5.2,6.866s6.788-1.3,7.394-4.413-1.719-6.189-5.2-6.866S341.335,76.99,340.729,80.1Z",
    transform: "translate(80.903 18.852)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M336.7,106.409l-39.716.483a3.459,3.459,0,0,0-3.006,4.818c4.332,10.443,13.061,15.466,22.981,15.344s18.5-5.351,22.77-15.9A3.4,3.4,0,0,0,336.7,106.409Z",
    transform: "translate(46.589 41.412)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M289.575,81.91c1.023,5.078,8.857,7.784,17.5,6.042s14.82-7.268,13.8-12.348-8.857-7.784-17.5-6.042S288.552,76.832,289.575,81.91Z",
    transform: "translate(43.485 14.08)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(333.586 122.676)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M295.722,91.888c-3.092-.121-5.725,3.021-5.883,7.019s2.223,7.337,5.315,7.46,5.725-3.021,5.883-7.019S298.814,92.011,295.722,91.888Z",
    transform: "translate(-289.832 -91.885)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M322.974,92.076c-3.092-.121-5.725,3.021-5.883,7.019s2.221,7.337,5.313,7.458,5.727-3.019,5.885-7.019S326.066,92.2,322.974,92.076Z",
    transform: "translate(-269.903 -91.748)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M289.839,98.31c-.158,4,2.223,7.337,5.315,7.458,2.109.083,3.982-1.369,5.024-3.56-2.606-3.2-5.227-6.4-7.935-9.508A8.088,8.088,0,0,0,289.839,98.31Z",
    transform: "translate(-289.832 -91.288)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M317.091,98.463c-.158,4,2.221,7.337,5.313,7.458a5.513,5.513,0,0,0,4.962-3.409c-2.72-3.13-5.379-6.312-7.936-9.574A8.092,8.092,0,0,0,317.091,98.463Z",
    transform: "translate(-269.903 -91.115)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M298.389,137.7s-1.454,19.29,5.857,27.711c0,0,3.56-9.318,11.911-7.9s11.149,9.532,11.149,9.532,17.908-11.565,16-26.539Z",
    transform: "translate(49.925 64.293)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M306.672,141.36s12.155-2.768,15.474,4.52-6.4,13.623-6.4,13.623-9.908,2.358-12.424-8.191S306.672,141.36,306.672,141.36Z",
    transform: "translate(53.162 66.594)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M318.906,156.147l.005-.156a8.428,8.428,0,0,0-13.875-7.069,8.758,8.758,0,0,0-1.768,2.143c-2.355-10.275,3.4-9.706,3.4-9.706s12.155-2.768,15.474,4.52c2.015,4.423-.772,8.487-3.275,11.006,0-.055-.016-.111-.016-.164C318.875,156.529,318.9,156.336,318.906,156.147Z",
    transform: "translate(53.166 66.594)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M298.339,141.091s2.46-4.986,6.44-6.473c0,0,1.7,6.9,11.982,6.956a17.2,17.2,0,0,0,14.8-8.516,51.114,51.114,0,0,1,9.3,5.429c5.28,3.786,2.58,18.4-15.853,25.784,0,0-3.883-15.441-8.639-16.013s-10.175,15.519-10.175,15.519S298.244,153.356,298.339,141.091Z",
    transform: "translate(49.975 60.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M301.688,141.138a88.388,88.388,0,0,1,13.269-2.337c.412,2.784,5.641,36.018,15.157,77,13.215-33.76,19.532-47.094,31.168-79.613,14.2.13,34.068,4.259,41.523,13.535,7.114,12.431-4.214,146.4-4.565,226.661-15.7,11.522-116.726,8.741-118.283-2.988-5.561-41.921-5.616-166.4-1.108-207.742C280.632,149.291,290.674,144.055,301.688,141.138Z",
    transform: "translate(33.357 63.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M363.472,234.271,325,232.571v4.915l38.014-.512Z",
    transform: "translate(69.472 133.672)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M275.64,233.859l28.478-1.288v4.915l-28.687-.391C275.406,236.025,275.664,234.936,275.64,233.859Z",
    transform: "translate(33.221 133.672)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M278.849,164.554c1.783-16.366,11.825-21.6,22.839-24.518a88.38,88.38,0,0,1,13.269-2.337c.412,2.784,5.641,36.018,15.157,77,1.619-4.136,4.61,156.783,4.195,167.818-27.605-.689-53.568-4.321-54.352-10.223C274.4,330.374,274.341,205.9,278.849,164.554Z",
    transform: "translate(33.357 64.293)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 29.118,
    height: 18.951,
    rx: 0.538,
    transform: "translate(415.006 282.982) rotate(-178.499)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "o",
    width: 25.52,
    height: 15.161,
    rx: 0.428,
    transform: "matrix(-1, -0.026, 0.026, -1, 413.258, 281.041)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "u",
    width: 7.595,
    height: 10.545,
    transform: "translate(411.543 277.923) rotate(-178.499)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M.151,0h11.7A.15.15,0,0,1,12,.15V1.225a.151.151,0,0,1-.151.151H.15A.15.15,0,0,1,0,1.225V.151A.151.151,0,0,1,.151,0Z",
    transform: "translate(401.69 268.874) rotate(-178.499)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M.151,0h11.7A.151.151,0,0,1,12,.151V1.225a.15.15,0,0,1-.15.15H.15A.15.15,0,0,1,0,1.225V.151A.151.151,0,0,1,.151,0Z",
    transform: "translate(401.63 271.165) rotate(-178.499)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M.15,0h11.7A.151.151,0,0,1,12,.151V1.225a.151.151,0,0,1-.151.151H.151A.151.151,0,0,1,0,1.225V.15A.15.15,0,0,1,.15,0Z",
    transform: "translate(401.569 273.457) rotate(-178.498)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M.15,0h11.7A.151.151,0,0,1,12,.151V1.225a.151.151,0,0,1-.151.151H.151A.151.151,0,0,1,0,1.225V.15A.15.15,0,0,1,.15,0Z",
    transform: "translate(401.509 275.749) rotate(-178.498)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M.15,0h11.7A.151.151,0,0,1,12,.151V1.225a.151.151,0,0,1-.151.151H.151A.151.151,0,0,1,0,1.225V.15A.15.15,0,0,1,.15,0Z",
    transform: "translate(401.449 278.041) rotate(-178.498)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "v",
    width: 2.522,
    height: 4.89,
    rx: 0.276,
    transform: "translate(402.708 265.002) rotate(-178.499)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M307.113,217.668c13.215-33.76,19.532-47.094,31.168-79.613a91.925,91.925,0,0,1,15.147,1.465c-.281,15.938-2.346,26.946-8.08,40.668-5.739-.9-8.431-.7-15.1-.235a139.129,139.129,0,0,1,13.544,4.908c-7.213,15.18-20.7,32.346-35.592,44.144-.123-4.228-1.236-7.223-1.125-11.5Z",
    transform: "translate(56.358 64.554)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M307.113,215.8c13.215-33.76,19.532-47.094,31.168-79.613a91.928,91.928,0,0,1,15.147,1.465c-.281,15.938-2.346,26.946-8.08,40.666-5.739-.9-8.431-.7-15.1-.234A139.11,139.11,0,0,1,343.792,183c-7.213,15.18-20.834,32.4-35.725,44.194.109-4.143-1.1-7.273-.992-11.549Z",
    transform: "translate(56.358 63.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M305.37,174.79c-5.46-.518-8.016-.6-12.315.265-2.555-11.016-4.437-24.17-1.859-35.3,5.329-.083,6.679-1.227,10.8-1.671.395,2.663,6.511,40.2,15.253,78.7.035,2.266,3.58,7.071,3.454,12.2-5.452-7.174-14.042-15.512-18.028-23.826a140.993,140.993,0,0,1-9.126-25.23C297.351,177.909,301.077,175.744,305.37,174.79Z",
    transform: "translate(43.851 64.575)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M307.379,172.706c-5.459-.519-8.556.142-12.857,1a157.832,157.832,0,0,1-4.072-33.568,87.823,87.823,0,0,1,13.656-2.445c.395,2.661,6.414,38.5,15.157,77,.033,2.265,1.08,6.257.954,11.387-5.454-7.174-11.542-14.7-15.528-23.014a141.075,141.075,0,0,1-9.127-25.23C299.36,175.826,303.088,173.66,307.379,172.706Z",
    transform: "translate(44.207 64.293)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(411.364 332.891)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M336.011,230.323s14.934,8.289,16.459,4.146-13.525-10.921-13.525-10.921Z",
    transform: "translate(-333.84 -205.817)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M335.2,237.768s10.957,7.24,14.435,3.336-10.727-8.968-10.727-8.968Z",
    transform: "translate(-334.436 -199.537)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M337.129,245.2s9.223,2.734,12.922.452.4-9.825-5.834-8.186A9.8,9.8,0,0,0,337.129,245.2Z",
    transform: "translate(-333.023 -195.811)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M376.787,224.41a11.51,11.51,0,0,0-2.623-2.793,39.939,39.939,0,0,0-7.006-3.843c-7.425-3.566-15.486-4.913-15.9-4.34l-2.54,4.191-5.445,42.924c1.775-.144,4.725-.291,6.049-.575,0,0,10.407-1.039,17.365-5.417,5.064-3.187,9.276-7.609,11.1-13.4C379.441,235.918,379.955,229.168,376.787,224.41Z",
    transform: "translate(-328.527 -213.306)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M345.117,241.917s14.06-3.172,14.5,1.143-15.744,8.1-17.791,6.368C340.255,248.106,345.117,241.917,345.117,241.917Z",
    transform: "translate(-329.817 -193.206)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M359.642,214.8s-27.169,13.163-24.558,19.749,11.728-1.982,11.728-1.982-15.63,13.639-11.295,17.872,16.885-11.9,16.885-11.9S331.32,257.89,338.863,261.6s14.917-12.441,14.917-12.441-12.817,16.485-7.017,19.276,14.8-15.356,14.8-15.356Z",
    transform: "translate(-334.757 -212.211)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(419.615 206.7)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M376.219,289.777l-14.513-16.037c-1.541-.793,35.247-31.038,48.5-56.31,1.745-3.328-4.361-13.419-31.378-34.451a140.3,140.3,0,0,0-39.307-21.423l9.131-21.139c.931.525,24.03,8.83,44.769,24.974,11.721,9.124,47.385,36.888,34.549,61.357C412.971,255.349,377.765,288.424,376.219,289.777Z",
    transform: "translate(-339.523 -140.418)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M382.744,226.288l-7.142,7.586a3.164,3.164,0,0,1-4.583.023l-14.641-15.256a2.6,2.6,0,0,1,.251-3.821l10.878-8.7Z",
    transform: "translate(91.891 114.327)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(418.355 204.486)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M393.3,279.245c-5.545-5.137-14.368-13.428-19.773-18.7a4.256,4.256,0,0,1-.009-6.091c10.817-10.611,22.87-22.768,30.129-36.61,1.747-3.328-.838-9.294-27.853-30.325a195.118,195.118,0,0,0-37-22.882l6.414-25.493c.931.523,29.842,9.706,50.579,25.85,11.723,9.124,52.138,37.139,37.5,64.636-8.546,16.047-22.339,36.393-33.807,49.328A4.322,4.322,0,0,1,393.3,279.245Z",
    transform: "translate(-338.795 -139.139)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(283.346 331.611)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M295.769,230.323s-14.936,8.289-16.459,4.146,13.525-10.921,13.525-10.921Z",
    transform: "translate(-247.366 -204.538)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M295.916,237.768s-10.957,7.24-14.437,3.336,10.729-8.968,10.729-8.968Z",
    transform: "translate(-246.102 -198.257)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M293.767,245.2s-9.223,2.734-12.922.452-.4-9.825,5.834-8.186A9.8,9.8,0,0,1,293.767,245.2Z",
    transform: "translate(-247.299 -194.531)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M263.126,224.951a11.52,11.52,0,0,1,2.625-2.793,39.925,39.925,0,0,1,7-3.843c7.427-3.566,13.284-6.241,13.693-5.67l3.47,5.537,6.719,42.908c-1.773-.144-4.723-.291-6.047-.575,0,0-10.407-1.039-17.365-5.417-5.066-3.187-9.278-7.609-11.1-13.4C260.472,236.458,259.959,229.708,263.126,224.951Z",
    transform: "translate(-260.813 -212.567)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M287.315,241.917s-14.06-3.172-14.5,1.143,15.743,8.1,17.791,6.368C292.175,248.106,287.315,241.917,287.315,241.917Z",
    transform: "translate(-252.041 -191.927)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M276.462,214.8s27.171,13.163,24.56,19.749-11.728-1.982-11.728-1.982,15.63,13.639,11.295,17.872-16.885-11.9-16.885-11.9,21.082,19.345,13.539,23.052-14.917-12.441-14.917-12.441,12.817,16.485,7.017,19.276-14.8-15.356-14.8-15.356Z",
    transform: "translate(-250.775 -210.932)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(241.962 208.573)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M257.421,218.513c-1.745-3.329,4.363-13.421,31.378-34.451a141.78,141.78,0,0,1,37.552-20.8q.015-2.3.04-4.59L318.977,141.5c-.932.525-24.032,8.83-44.771,24.974-11.721,9.124-47.385,36.887-34.549,61.357,15,28.6,50.209,61.675,51.755,63.029l14.513-16.037C303.532,276.053,269.614,241.759,257.421,218.513Z",
    transform: "translate(-236.909 -141.5)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M253.695,225.174l7.142,7.585a3.16,3.16,0,0,0,4.581.023l14.641-15.256a2.593,2.593,0,0,0-.251-3.821L268.93,205Z",
    transform: "translate(17.328 113.512)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.834 205.817)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M295.986,186.952a204.942,204.942,0,0,1,32.091-20.5q.049-10.4.265-20.829l-1.437-5.715c-.931.525-30.178,8.374-50.917,24.518-11.721,9.124-53,40.365-38.36,67.861,7.6,14.262,18.416,31.906,28.855,44.738a3.451,3.451,0,0,0,5.04.357c6.153-5.76,13.433-13.263,19.383-18.165l.436-.358a5.029,5.029,0,0,0,.473-7.313,163.028,163.028,0,0,1-23.682-34.269C266.386,213.95,268.971,207.984,295.986,186.952Z",
    transform: "translate(-234.525 -139.908)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "ab",
    transform: "translate(237.834 205.817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.986,186.952a204.942,204.942,0,0,1,32.091-20.5q.049-10.4.265-20.829l-1.437-5.715c-.931.525-30.178,8.374-50.917,24.518-11.721,9.124-53,40.365-38.36,67.861,7.6,14.262,18.416,31.906,28.855,44.738a3.451,3.451,0,0,0,5.04.357c6.153-5.76,13.433-13.263,19.383-18.165l.436-.358a5.029,5.029,0,0,0,.473-7.313,163.028,163.028,0,0,1-23.682-34.269C266.386,213.95,268.971,207.984,295.986,186.952Z",
    transform: "translate(-234.525 -139.908)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M310.086,205.523a3.834,3.834,0,1,0,3.835-3.835A3.834,3.834,0,0,0,310.086,205.523Z",
    transform: "translate(58.565 111.088)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M310.086,222.829a3.834,3.834,0,1,0,3.835-3.835A3.834,3.834,0,0,0,310.086,222.829Z",
    transform: "translate(58.565 123.743)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M310.086,243.378a3.834,3.834,0,1,0,3.835-3.833A3.835,3.835,0,0,0,310.086,243.378Z",
    transform: "translate(58.565 138.772)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDentistCaricature);
export default __webpack_public_path__ + "static/media/dentistCaricature.4c9ee8ffcb61ef0096c89f7a0027ca8e.svg";
export { ForwardRef as ReactComponent };